// extracted by mini-css-extract-plugin
module.exports = {"customBadge":"NTagItem_customBadge__2zagx","active":"NTagItem_active__3iVQA"};